<template>
      <canvas v-visible.once="drawPage" v-bind="canvasAttrs"></canvas>
</template>

<script>
import pdfjs from 'pdfjs-dist';
import {PIXEL_RATIO} from './utils/constants';
import visible from './directives/visible';

export default {
  name: 'PDFPage',

  components: {
  },

  props: {
    page: {
      type: Object,
      required: true,
    },
    pdfid: {
      required: false,
      default: false,
    },
    scale: {
      type: Number,
      required: true,
    },
    optimalScale: {
      type: Number,
      required: true,
    },
    isPageFocused: {
      type: Boolean,
      default: false,
    },
    isElementFocused: {
      type: Boolean,
      default: false,
    },
    isPageOrderable: {
      type: Boolean,
      default: false,
    },
    fit: {
      type: String,
    }
  },

  data() {
    return {
      signatureSuggestedPage: []
    }
  },

  directives: {
    visible,
  },

  computed: {


    canvasStyle() {
      const {viewport} = this;
      const [pixelWidth, pixelHeight] = [(viewport.width/viewport.scale)*2,(viewport.height/viewport.scale)*2]

      if (this.fit == 'fixed') return `width: ${pixelWidth}px!important; height: ${pixelHeight}px!important; max-width: none!important;`;
      return `width: ${pixelWidth}px; height: ${pixelHeight}px; `;
    },

    canvasAttrs() {
      const {viewport} = this;
      const style = this.canvasStyle;

      return {
        height: (viewport.height/viewport.scale)*2,
        width: (viewport.width/viewport.scale)*2,
        style,
        class: 'pdf-page box-shadow',
      };
    },

    pageNumber() {
      if (this.pdfid) return `${this.page.pageNumber}${this.pdfid}`;
      return this.page.pageNumber;
    },
  },

  methods: {
    focusPage() {
      if (this.isPageFocused) return;
      this.$bus.$emit('pdf::page::visibility::focus', this.pageNumber);
    },

    drawPage(restoring = false) {
      if (this.renderTask) return;
      // const {viewport} = this;
      const viewport = this.page.getViewport(this.canvasAttrs.width / this.page.getViewport(1.0).width);
      const canvasContext = this.$el.getContext('2d');
      const annotationLayer = document.getElementById("annotation-" + this.pageNumber).getElementsByClassName("annotations")[0].getElementsByClassName("wrapper")[0].getElementsByClassName("textLayer")[0];
      const renderContext = {canvasContext, viewport};

      let textViewport = viewport.clone();


      this.page.render(renderContext)
        .then(() => {
          return this.page.getTextContent();
        })
        .then((textContent) => {
          const textLayer =  pdfjs.renderTextLayer({
            textContent: textContent,
            container: annotationLayer,
            viewport: textViewport,
            textDivs: []
          });
          textLayer._render();
        })
        .then(() => {
          this.$bus.$emit('pdf::page::rendered', {
            page: this.page,
            text: `Rendered page ${this.pageNumber}`,
          });

        })
      .catch(response => {
        this.destroyRenderTask();
        this.$bus.$emit('pdf::page::errored', {
          response,
          page: this.page,
          text: `Failed to render page ${this.pageNumber}`,
        });
      });
    },

    updateVisibility() {
      this.$bus.$emit('pdf::page::visibility::update');
    },

    destroyPage(page) {
      // if (page) page._destroy();
      // this.destroyRenderTask();
    },

    destroyRenderTask() {
      if (!this.renderTask) return;
      this.renderTask.cancel();
      delete this.renderTask;
    },

    restorePage(page) {
        if (page != this.page) return;
        this.renderTask = false;
        this.drawPage(true);
    },
  },

  watch: {
    scale: 'updateVisibility',

    page(_newPage, oldPage) {
      this.destroyPage(oldPage);
    },

    isElementFocused(isElementFocused) {
      if (isElementFocused) this.focusPage();
    },
  },

  created() {
    this.viewport = this.page.getViewport(this.optimalScale);
    this.$bus.$on('pdf::page::restore', this.restorePage);
  },

  beforeDestroy() {
    this.destroyPage(this.page);
    // this.$bus.$off("pdf::page::restore");
  },
};
</script>
<style lang="scss">
.pdf-page {
  display: block;
  margin: 0 auto;
  border: 1px solid #d0d0d0;
  box-shadow: 0 0 25px -15px
}

[class^="textLayer"] {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    opacity: 0.2;
    line-height: 1.0;
    & > section {
        color: transparent;
        position: absolute;
        white-space: pre;
        cursor: text;
        transform-origin: 0% 0%;
    }

    & > .linkAnnotation {

      & > a {
      position: absolute;
      font-size: 1em;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

    }
  }
}
</style>
